import { t } from '../i18n/i18n'
import { handleMessage } from './stateHelper'
import { IDataContext } from '../interfaces/IDataContext'
import { Organisation } from '../api/schemas/schema'
import { api } from './apiHelper'

export const downloadOrganisationContract = async (organisation: Organisation, dataContext: IDataContext) => {
   try {
      const { accessToken } = dataContext.state
      const contract: any = await api(accessToken).getOrganisationContract(organisation)

      if (contract?.data?.result) {
         const byteCharacters = atob(contract.data.result)
         const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i))
         const byteArray = new Uint8Array(byteNumbers)
         const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
         })

         downloadFile(blob, `${t('OrganisationContractFileName')}_${organisation.name}.docx`)
         handleMessage(dataContext.setRootState, 'success', t('ContractIsCreatedAndDownloaded'), '')
      } else {
         throw new Error('No file data found in the response.')
      }
   } catch (error) {
      handleMessage(dataContext.setRootState, 'error', t('CouldNotDownloadContract'), '')
   }
}
const downloadFile = (blob: Blob, filename: string) => {
   const url = URL.createObjectURL(blob)
   const link = document.createElement('a')

   link.href = url
   link.download = filename
   document.body.appendChild(link)
   link.click()

   URL.revokeObjectURL(url)
   link.remove()
}
